import Axios from "../connection";
import { applicationError } from "../../../redux/actions/error";

export const afGetCountries = () => {
  return new Promise((resolve) => {
    Axios.get("/countries")
      .then((response) => {
        resolve(response.data.response);
      })
      .catch((err) => {
        applicationError({
          err,
          message: "Unable to fetch country details",
          errorCode: "api-football",
        });
      });
  });
};
